// src/components/LoanAgainstProperty.js
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./LoanAgainstProperty.css";
import Calculator from "../common/calculator";
import Banklist from "../common/Banklist/Banklist";
import LoanForm from "../common/Form/Form";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";

const LoanAgainstProperty = () => {
  const navigate = useNavigate();

  return (
    <div>
      <section className="lap-hero">
        <div className="lap-container">
          {/* LEFT VIDEO */}
          <div className="lap-video">
            <img
              src="/images/p.png"
              alt="Loan Against Property"
              className="hero-video"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="lap-content">
            <h1>
              Unlock the Value of Your Property with
              <span> Loan Against Property!</span>
            </h1>

            <ul className="lap-points">
              <li>✔ High Loan Amount</li>
              <li>✔ Competitive Interest Rates</li>
              <li>✔ Flexible Usage of Funds</li>
            </ul>

            <p>
              Loan Against Property (LAP) is a smart way to unlock the financial
              value of your residential or commercial property. It allows you to
              access funds while continuing to own and use your property.
            </p>

            <p>
              Whether you need funds for business expansion, education, medical
              expenses, or personal needs, our loan solutions offer competitive
              interest rates and flexible repayment options.
            </p>

            <p>
              With minimal documentation and a simple application process, you
              can enjoy quick approvals and access the funds you need in a
              smooth and hassle-free manner.
            </p>
          </div>
        </div>
      </section>
      <section className="loan-usage-section">
        <div className="loan-container">
          <div className="loan-left">
            <h2>
              Unlock the Value of Your <span>Property</span>
            </h2>

            <p>
              A Loan Against Property allows you to use your residential or
              commercial property as collateral to access funds for your
              personal or business needs. It offers higher loan amounts and
              lower interest rates compared to unsecured loans.
            </p>

            <p>
              <strong>Krishana Finconcept Services</strong> provides reliable
              loan against property solutions with quick approvals, flexible
              repayment options, and competitive interest rates.
            </p>
          </div>

          <div className="loan-right">
            <div className="loan-card">
              <h4>Business Expansion</h4>
              <p>
                Get funds to grow your business, invest in equipment, or expand
                operations.
              </p>
            </div>

            <div className="loan-card">
              <h4>Education Expenses</h4>
              <p>
                Finance higher education for yourself or your children with
                ease.
              </p>
            </div>

            <div className="loan-card">
              <h4>Medical Emergencies</h4>
              <p>
                Manage unexpected medical expenses without financial stress.
              </p>
            </div>

            <div className="loan-card">
              <h4>Debt Consolidation</h4>
              <p>
                Combine multiple loans into a single loan with lower interest
                rates.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="homeload-main-section homeloan-section modern-variant unique-hero-design full-width-layout">
        <div className="homeloan-hero-text animated-entrance">
          {/* 1. Badge */}
          <div className="badge-glow animated-item">
            Unlock Your Property's Value
          </div>

          {/* 2. Main Title */}
          <h1 className="title animated-item">
            Get Maximum Funding With <span>Loan Against Property!</span>
          </h1>

          {/* 3. Features Pills */}
          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> High Loan Amount
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Lower Interest Rates
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Longer Tenure Options
            </div>
          </div>

          {/* 4. Description Body */}
          <div className="content-body animated-item">
            <p className="subtitle">
              Leverage your residential or commercial property to meet your
              big-ticket financial needs. <strong>Krishana Finconcept</strong>{" "}
              offers seamless Loan Against Property solutions with competitive
              rates and high LTV (Loan to Value).
            </p>

            <p className="subtitle">
              Whether it is for business expansion, debt consolidation, or
              funding higher education, our LAP services provide you with the
              liquidity you need without having to sell your valuable assets.
            </p>

            <p className="subtitle">
              Experience a transparent process, quick appraisal, and doorstep
              service designed to make your borrowing experience stress-free and
              efficient.
            </p>
          </div>

          {/* 5. Action Button */}
          <div className="cta-wrapper animated-item">
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/3", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Loan Against Property</span>
              <div className="btn-glow-shimmer"></div>
            </button>
          </div>
        </div>
      </section>

      <TestimonialsSection />

      <Services
        slug="3"
        title=" Loan Against Property EMI Calculator – Calculate Your Monthly EMI
            Online"
      />
    </div>
  );
};

export default LoanAgainstProperty;
